<template>
  <div class="dim" id="pop-policy1" style="display: block">
    <div class="popup-policy">
      <h2>
        {{ $ConstCode.labelTermsType(data.type) }}
        <button class="btn-x" @click="fnClose">x버튼</button>
      </h2>
      <section class="inner" v-html="data.contents"></section>
      <section class="btn-area">
        <button @click="fnClose">확인</button>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal-alert-terms',
  props: {
    index: {
      type: [Number],
      default: 0
    },
    layout: {
      type: [Object],
      default: () => {}
    },
    data: {
      type: [Object],
      default: () => {}
    },
    callBack: {
      type: [Function],
      default: () => {}
    }
  },
  setup(props, context) {
    const fnClose = () => {
      context.emit('close', props.index)
    }
    const fnCallBack = (event) => {
      props.callBack(event)
    }
    return { fnClose, fnCallBack }
  }
}
</script>

<style scoped></style>
